export const cprValidator = (input) => {
  if (!input) {
    return false;
  }

  let cpr = "";
  if (typeof input === "string") {
    cpr = input.replace("-", "");
  } else {
    cpr = input.toString();
  }

  const is10Digits = /^\d{10}$/.test(cpr);
  if (!is10Digits) {
    return false;
  }

  const day = cpr.substring(0, 2);
  const month = parseInt(cpr.substring(2, 4)) - 1;
  let year = cpr.substring(4, 6);
  const control = parseInt(cpr.substring(6, 10));

  // https://cpr.dk/media/12066/personnummeret-i-cpr.pdf
  if (control >= 4000) {
    year = 2000 + year;
  }

  const date = new Date(year, month, day);

  // Check for Leap year and invalid dates
  if (day != date.getDate()) {
    return false;
  }

  if (month != date.getMonth()) {
    return false;
  }

  return true;
};
